module.exports = __webpack_public_path__ + "static/img/8areaB_10.79ca812.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/8areaB_10.png
// module id = 1230
// module chunks = 1